import React from 'react';

import Tooltip from '@atlaskit/tooltip';

import { handleJiraIssueLinkClick } from 'src/connect/jira-issue-dialog/jira-issue-dialog';
import { JiraIssue } from 'src/redux/jira/types';
import { UiEvent } from 'src/utils/analytics/publish';

import * as styles from './jira-issue-link.style';

type Props = {
  jiraIssue: JiraIssue;
  jiraUrl: string;
  uiEvent: UiEvent;
};

export const JiraIssueLink = ({ jiraIssue, jiraUrl, uiEvent }: Props) => {
  // Temporarily disabling the iframe dialogue and opening in new tab
  // Until COREX-4701 is completed to fix the iframe dialogue
  /* eslint-disable @typescript-eslint/no-unused-vars */
  // @ts-ignore
  const handleClick = (e: React.MouseEvent) => {
    handleJiraIssueLinkClick(e, uiEvent, jiraUrl, jiraIssue.key);
  };
  /* eslint-enable @typescript-eslint/no-unused-vars */

  // The Jira API doesn't return user-friendly links. Constructing the URL using the key
  // is the currently recommended way according to our Jira insider :).
  const issueUrl = `${jiraUrl}/browse/${jiraIssue.key}`;

  return (
    <styles.IssueLink href={issueUrl} target="_blank">
      <Tooltip content={jiraIssue.issueType.name}>
        <styles.JiraIssueTypeIconContainer>
          <styles.JiraIssueTypeIcon
            src={jiraIssue.issueType.iconUrl}
            alt={jiraIssue.issueType.name}
          />
        </styles.JiraIssueTypeIconContainer>
      </Tooltip>
      <styles.IssueSummaryWrapper>
        <Tooltip content={`${jiraIssue.key}: ${jiraIssue.summary}`}>
          <styles.IssueSummary>
            <styles.IssueKey>{jiraIssue.key}</styles.IssueKey>
            <span>{jiraIssue.summary}</span>
          </styles.IssueSummary>
        </Tooltip>
      </styles.IssueSummaryWrapper>
    </styles.IssueLink>
  );
};
